/**
 * Microsoft Entra ID Login-Button (Phase P13, ADR-030).
 *
 * Sichtbarkeitsmodell (QM8D Rev.1000 · FIX-01):
 *   1. Build-Time-Flag ``REACT_APP_ENTRA_ENABLED`` (Fallback / Legacy).
 *   2. Runtime-Quelle: ``GET /api/v1/auth/login-methods.entra`` (bevorzugt).
 *
 * Die Sichtbarkeitsentscheidung trifft die Login-Page (siehe ``Login.js``);
 * dieser Button rendert sich nur dann nicht selbst, wenn weder die
 * ``visible``-Prop noch der Build-Flag aktiv sind. So bleibt der bisherige
 * Aufruf ``<MicrosoftLoginButton />`` voll abwaertskompatibel.
 *
 * Klick: Top-Level-Redirect zu ``/api/v1/auth/entra/login`` (Cookie-only,
 * kein Token in URL/localStorage — R-12).
 */
import React from 'react';
import { API } from '../../lib/axiosClient';
import { useLanguage } from '../../contexts/LanguageContext';

export const ENTRA_ENABLED =
  (process.env.REACT_APP_ENTRA_ENABLED || '').toLowerCase() === 'true';

export function MicrosoftLoginButton({ returnTo = '/', visible }) {
  const { t } = useLanguage();
  const shouldRender = visible === undefined ? ENTRA_ENABLED : Boolean(visible);
  if (!shouldRender) return null;

  const label = t('auth.entra.signIn', t('auth.entra.buttonLabel', 'Mit Microsoft anmelden'));

  const handleClick = () => {
    const target = `${API}/v1/auth/entra/login?return_to=${encodeURIComponent(returnTo)}`;
    window.location.href = target;
  };

  return (
    <button
      type="button"
      data-testid="microsoft-login-button"
      aria-label={label}
      onClick={handleClick}
      className="w-full py-3.5 rounded-xl text-sm font-bold border-[1.5px] border-gray-200 bg-white text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-center gap-3"
    >
      <svg width="18" height="18" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      {label}
    </button>
  );
}

export default MicrosoftLoginButton;
